<div class="headerPanel mat-elevation-z4">
  <button
    class="buttonIcon"
    mat-mini-fab
    aria-label="icon"
    (click)="botonDesplegableShadow()"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <p class="nombrePaciente" *ngIf="nombreApellido">
    Paciente: {{ nombreApellido }}
  </p>

  <div class="end">
    <div class="divCampana" [matMenuTriggerFor]="notificacion">
      <span *ngIf="notificacionesPush.length>0" class="contador">{{notificacionesPush.length}}</span>
      <img src="assets/img/ico_campana.png" class="iconCampana" />
    </div>
    <img [src]="imagen" class="icon" [matMenuTriggerFor]="appMenu" />

    <mat-menu class="custom-menu" #notificacion="matMenu">
      <div class="divNotification" (click)="onMenuItemClick($event)">
        <div class="tituloNotificacion">Notificaciones</div>
        <mat-nav-list class="list">
          <div *ngIf="notificacionesPush.length>0">
            <div class="notificationPush" *ngFor="let notificacionPush of notificacionesPush">
              <div *ngIf="notificacionPush.texto.length > 120" class="notificationText">
                {{notificacionPush.texto.substr(0,120).trim()}}...</div>
              <div *ngIf="notificacionPush.texto.length <= 120" class="notificationText">
                {{notificacionPush.texto}}</div>
              <div class="divIcon">
                <div class="divIconLink" (click)="leerNotificacion(notificacionPush)">
                  <mat-icon class="iconLink">visibility</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </mat-nav-list>
        <div *ngIf="notificacionesPush.length<1" class="mensaje">
          <span class="mensajeText">
            No hay notificaciones nuevas
          </span>
        </div>
      </div>
    </mat-menu>

    <mat-menu #appMenu="matMenu" class="dropdown">
      <mat-nav-list>
        <a
          mat-list-item
          class="buttonDash"
          [routerLink]="['/seccion-paciente/editar-perfil']"
          >Editar Perfil</a
        >
        <a mat-list-item class="buttonDash" (click)="logout()">Salir</a>
      </mat-nav-list>
    </mat-menu>
  </div>
</div>
